import { styled, Button, Checkbox, DialogActions } from "@material-ui/core";

const accent = "#ff5b5b";
const accentDark = "#ed4f4f";
const accentLight = "#fff1f1";

export const Page = styled("div")({
  color: "#222222",
  fontSize: 13,
  paddingBottom: 32,
});

export const StatusRow = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 16,
  padding: "28px 8px",
});

export const StatsToggle = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
  marginBottom: 6,
});

export const Metrics = styled("section")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
  gap: 14,
  marginBottom: 16,
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
  },
  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
  },
}));

export const Metric = styled("article")({
  minWidth: 0,
  padding: "18px 20px 16px",
  background: "#ffffff",
  border: "1px solid #d8d8d8",
  borderRadius: 3,
  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.07)",
  "&.up": { borderColor: "#4c8b65" },
  "&.down": { borderColor: "#b4665e" },
});

export const MetricLabel = styled("div")({
  marginBottom: 11,
  fontSize: 16,
  fontWeight: 600,
});

export const MetricPrimary = styled("div")({
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "space-between",
  gap: 6,
  flexWrap: "wrap",
  paddingBottom: 11,
  borderBottom: "1px solid #ededed",
});

export const MetricNumber = styled("div")({
  fontSize: 28,
  fontWeight: 700,
  letterSpacing: "-0.025em",
  lineHeight: 1.1,
});

export const MetricPeriod = styled("div")({
  marginTop: 4,
  color: "#555555",
  fontSize: 12,
});

export const Change = styled("span")({
  fontSize: 12,
  fontWeight: 600,
  whiteSpace: "nowrap",
  "&.up": { color: "#2f7c4f" },
  "&.down": { color: "#ef4444" },
  "&.flat": { color: "#555555" },
});

export const MetricLines = styled("div")({
  display: "grid",
  gap: 8,
  marginTop: 12,
});

export const MetricLine = styled("div")({
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr) auto auto",
  columnGap: 8,
  alignItems: "baseline",
  fontSize: 12,
  lineHeight: 1.45,
  "&.last": {
    paddingTop: 9,
    borderTop: "1px solid #ededed",
  },
});

export const CompareButton = styled("button")({
  marginTop: 11,
  padding: "10px 0 0",
  border: 0,
  borderTop: "1px solid #ededed",
  background: "transparent",
  color: "#555555",
  font: "inherit",
  cursor: "pointer",
  textAlign: "left",
});

export const CompareList = styled("dl")({
  margin: "7px 0 0",
  color: "#555555",
  fontSize: 12,
  "& div": {
    display: "flex",
    justifyContent: "space-between",
    gap: 8,
    padding: "4px 0",
  },
  "& dt": { color: "#444444" },
  "& dd": { margin: 0 },
});

export const Workflow = styled("section")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: 15,
  marginBottom: 15,
  padding: "16px 20px",
  background: "#ffffff",
  border: "1px solid #d8d8d8",
  borderRadius: 3,
  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.07)",
  [theme.breakpoints.down("sm")]: {
    flexWrap: "wrap",
    alignItems: "flex-start",
  },
}));

export const WorkflowTitle = styled("span")({
  display: "flex",
  alignItems: "center",
  gap: 8,
  fontSize: 16,
  fontWeight: 600,
  whiteSpace: "nowrap",
});

export const WorkflowTotal = styled("span")({
  padding: "2px 5px",
  borderRadius: 2,
  background: "#f0f0f0",
  color: "#555555",
  fontSize: 12,
  fontWeight: 400,
});

export const Pills = styled("div")(({ theme }) => ({
  display: "flex",
  flex: 1,
  flexWrap: "wrap",
  gap: 8,
  minWidth: 0,
  [theme.breakpoints.down("sm")]: { flexBasis: "100%" },
}));

export const Pill = styled("button")({
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  padding: "7px 10px",
  border: "1px solid #cfcfcf",
  borderRadius: 3,
  background: "#ffffff",
  color: "#222222",
  font: "inherit",
  fontSize: 12,
  cursor: "pointer",
  "& strong": { fontWeight: 600 },
  "&:hover, &.active": {
    background: accentLight,
    borderColor: accent,
    color: accent,
  },
});

export const Queues = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
  gap: 10,
  padding: "16px 20px",
  background: "#ffffff",
  border: "1px solid #d8d8d8",
  borderRadius: 3,
  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.07)",
  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
  },
}));

export const QueuePair = styled("div")({
  display: "grid",
  gridTemplateRows: "repeat(2, minmax(36px, 1fr))",
  gap: 10,
  minWidth: 0,
});

export const QueueButton = styled("button")({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 7,
  width: "100%",
  minHeight: 36,
  padding: "7px 10px",
  border: "1px solid #cfcfcf",
  borderRadius: 3,
  background: "#ffffff",
  color: "#222222",
  font: "inherit",
  fontSize: 12,
  lineHeight: 1.4,
  cursor: "pointer",
  "&:hover": { background: "#fafafa" },
  "&.active": {
    background: accent,
    borderColor: accent,
    color: "#ffffff",
  },
  "&.active:hover": { background: accentDark },
});

export const QueueCount = styled("span")({
  flex: "none",
  padding: "1px 4px",
  borderRadius: 2,
  background: "#f0f0f0",
  color: "#555555",
  fontSize: 12,
  ".active &": {
    background: "rgba(255,255,255,.22)",
    color: "#ffffff",
  },
});

export const UnreadBadge = styled("span")({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 19,
  height: 19,
  padding: "0 4px",
  borderRadius: 99,
  background: "#ed3636",
  color: "#ffffff",
  fontSize: 12,
  fontWeight: 700,
  lineHeight: 1,
});

export const QueueBadge = styled(UnreadBadge)({
  position: "absolute",
  top: -7,
  right: -5,
  boxShadow: "0 0 0 2px #ffffff",
});

export const Tools = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "space-between",
  gap: 12,
  margin: "18px 0 14px",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    alignItems: "stretch",
  },
}));

export const Results = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: 10,
  color: "#444444",
  fontSize: 12,
});

export const Filters = styled("div")(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "flex-end",
  justifyContent: "flex-end",
  gap: 10,
  [theme.breakpoints.down("sm")]: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    width: "100%",
  },
}));

export const SearchField = styled("div")(({ theme }) => ({
  minWidth: 220,
  [theme.breakpoints.down("sm")]: { gridColumn: "1 / -1", minWidth: 0 },
}));

export const SortField = styled("div")(({ theme }) => ({
  width: 180,
  [theme.breakpoints.down("sm")]: { gridColumn: "1 / -1", width: "auto" },
}));

export const SortHint = styled("p")({
  minHeight: 0,
  margin: "-6px 0 10px",
  color: "#555555",
  fontSize: 12,
  "&:empty": { display: "none" },
});

export const Columns = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1.4fr) minmax(0, 1.2fr)",
  padding: "0 0 10px",
  color: "#333333",
  fontSize: 13,
  fontWeight: 500,
  "& div": { paddingLeft: 20 },
  [theme.breakpoints.down("md")]: { display: "none" },
}));

export const Entry = styled("article")({
  marginBottom: 16,
  background: "#ffffff",
  border: "1px solid #dfdfdf",
  borderRadius: 3,
  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.07)",
});

export const EntryMain = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1.4fr) minmax(0, 1.2fr)",
  "& > div": { minWidth: 0, padding: 20 },
  "& > div + div": { borderLeft: "1px solid #e5e5e5" },
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1.25fr)",
  },
  [theme.breakpoints.down("sm")]: {
    display: "flex",
    flexDirection: "column",
    "& > div + div": { borderLeft: 0, borderTop: "1px solid #e5e5e5" },
  },
}));

export const NotesColumn = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  [theme.breakpoints.down("md")]: {
    gridColumn: "1 / -1",
    borderLeft: "0 !important",
    borderTop: "1px solid #e5e5e5",
  },
}));

export const ReferenceRow = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "baseline",
  gap: "5px 9px",
  paddingBottom: 12,
  borderBottom: "1px solid #ededed",
});

export const HeaderRow = styled("div")({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: 8,
});

export const Muted = styled("span")({
  color: "#777777",
  fontSize: 12,
});

export const Age = styled("span")({
  color: "#444444",
  fontSize: 12,
  fontWeight: 600,
});

export const TextButton = styled(Button)({
  minWidth: 0,
  padding: 0,
  color: accent,
  fontSize: 12,
  fontWeight: 400,
  lineHeight: 1.4,
  textTransform: "none",
  "&:hover": {
    backgroundColor: "transparent",
    color: accentDark,
    textDecoration: "underline",
  },
  "&.MuiButton-text": { color: accent },
  "&.MuiButton-text:hover": {
    backgroundColor: "transparent",
    color: accentDark,
  },
});

export const CustomerLine = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: "7px 10px",
  padding: "12px 0",
  borderBottom: "1px solid #ededed",
  fontSize: 13,
});

export const InlineButton = styled("button")({
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  maxWidth: "100%",
  padding: 0,
  border: 0,
  background: "transparent",
  color: "#333333",
  font: "inherit",
  textAlign: "left",
  cursor: "pointer",
  "&:hover": { textDecoration: "underline" },
});

export const TripDate = styled("span")({
  fontSize: 13,
  fontWeight: 600,
  "&.expired": { color: "#ef4444" },
});

export const TripStat = styled("span")({
  color: "#444444",
  fontSize: 13,
  "& b": { color: "#333333", fontWeight: 500 },
});

export const TripLine = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "baseline",
  gap: "5px 8px",
  paddingTop: 12,
  lineHeight: 1.6,
});

export const BoatInterest = styled("div")({
  marginTop: 5,
  color: "#666666",
  fontSize: 13,
  lineHeight: 1.6,
  "& strong": { color: "#333333", fontWeight: 500 },
});

export const BookingState = styled("div")({
  marginTop: 6,
  color: "#666666",
  fontSize: 12,
});

export const Warning = styled("div")({
  display: "inline-flex",
  marginTop: 8,
  padding: "4px 6px",
  borderRadius: 2,
  background: "#fff7e8",
  color: "#9b6500",
  fontSize: 12,
  fontWeight: 500,
});

export const CustomerActions = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  gap: 8,
  marginTop: 14,
  paddingTop: 14,
  borderTop: "1px solid #ededed",
  "& details": { fontSize: 12 },
  "& summary": {
    display: "inline-flex",
    alignItems: "center",
    minHeight: 33,
    padding: "7px 10px",
    border: `1px solid ${accent}`,
    borderRadius: 3,
    background: "#ffffff",
    color: accent,
    textTransform: "uppercase",
    cursor: "pointer",
    listStyle: "none",
  },
  "& summary::-webkit-details-marker": { display: "none" },
  "& summary:hover": { background: accentLight },
});

export const DetailGrid = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "3px 22px",
  width: "100%",
  marginTop: 12,
  [theme.breakpoints.down("sm")]: { gridTemplateColumns: "1fr" },
}));

export const InfoPair = styled("div")({
  display: "grid",
  gridTemplateColumns: "minmax(80px, 0.8fr) minmax(0, 1.2fr)",
  gap: 10,
  padding: "4px 0",
  fontSize: 12,
  lineHeight: 1.6,
  "& span": { color: "#555555" },
  "& strong": { color: "#333333", fontWeight: 550, overflowWrap: "anywhere" },
});

export const Kicker = styled("div")({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: 10,
  marginBottom: 10,
  color: "#777777",
  fontSize: 12,
});

export const Tag = styled("span")({
  padding: "3px 6px",
  borderRadius: 2,
  background: "#f3f3f3",
  color: "#555555",
  fontSize: 12,
});

export const TaskTitle = styled("h3")({
  margin: "0 0 8px",
  fontSize: 15,
  fontWeight: 600,
  lineHeight: 1.4,
});

export const TaskBody = styled("p")({
  margin: 0,
  color: "#555555",
  fontSize: 13,
  lineHeight: 1.65,
  whiteSpace: "pre-line",
  overflowWrap: "anywhere",
});

export const TaskActions = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  gap: 8,
  marginTop: 13,
});

export const Availability = styled("div")({
  marginTop: 17,
  paddingTop: 13,
  borderTop: "1px solid #ededed",
});

export const AvailabilityHead = styled("div")({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: 8,
  marginBottom: 8,
  fontSize: 13,
  fontWeight: 600,
});

export const BoatLine = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 9,
  padding: "8px 0",
  borderTop: "1px solid #ededed",
});

export const BoatName = styled("span")({
  minWidth: 0,
  fontSize: 13,
  overflowWrap: "anywhere",
});

export const BoatState = styled("span")({
  flexShrink: 0,
  maxWidth: "48%",
  padding: "3px 6px",
  borderRadius: 2,
  background: "#f3f3f3",
  color: "#555555",
  fontSize: 12,
  textAlign: "right",
  "&.available": { background: "#f1f6f3", color: "#3d6b52" },
  "&.conflict": { background: "#fff1f1", color: "#ef4444" },
});

export const AvailabilityFoot = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 8,
  paddingTop: 11,
  borderTop: "1px solid #ededed",
  color: "#555555",
  fontSize: 12,
});

export const NoteHeading = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: 6,
  color: "#555555",
  fontSize: 13,
  fontWeight: 500,
});

export const NoteBody = styled("div")({
  flex: 1,
  minHeight: 150,
  padding: 12,
  border: "1px solid #cfcfcf",
  borderRadius: 3,
  color: "#444444",
  fontSize: 13,
  lineHeight: 1.65,
  whiteSpace: "pre-wrap",
  overflowWrap: "anywhere",
});

export const CardActions = styled("div")({
  display: "flex",
  gap: 10,
  marginTop: "auto",
  paddingTop: 14,
  borderTop: "1px solid #ededed",
  "& button": { flex: 1 },
});

export const LastAction = styled("div")({
  marginTop: 9,
  color: "#777777",
  fontSize: 12,
  lineHeight: 1.5,
  overflowWrap: "anywhere",
});

export const ActionPanel = styled("div")({
  padding: "18px 20px",
  borderTop: "1px solid #ededed",
});

export const ActionGrid = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
  gap: 18,
  [theme.breakpoints.down("md")]: { gridTemplateColumns: "repeat(2, minmax(0, 1fr))" },
  [theme.breakpoints.down("sm")]: { gridTemplateColumns: "1fr" },
}));

export const ActionLabel = styled("div")({
  marginBottom: 9,
  color: "#444444",
  fontSize: 13,
  fontWeight: 600,
});

export const ActionButtons = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  gap: 6,
});

export const PanelMeta = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  marginTop: 14,
  paddingTop: 10,
  borderTop: "1px solid #ededed",
});

export const Empty = styled("div")({
  padding: "50px 20px",
  background: "#ffffff",
  border: "1px solid #d8d8d8",
  borderRadius: 3,
  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.07)",
  color: "#444444",
  textAlign: "center",
  "& strong": { display: "block", marginBottom: 12, color: "#333333", fontSize: 14 },
});

const actionButton = {
  borderRadius: 3,
  boxShadow: "none",
  fontSize: 12,
  fontWeight: 500,
  letterSpacing: 0,
  textTransform: "uppercase",
};

export const PrimaryButton = styled(Button)({
  ...actionButton,
  backgroundColor: accent,
  border: `1px solid ${accent}`,
  color: "#ffffff",
  "&:hover": { backgroundColor: accentDark, borderColor: accentDark },
  "&.MuiButton-text": { backgroundColor: accent, color: "#ffffff" },
  "&.MuiButton-text:hover": { backgroundColor: accentDark, borderColor: accentDark },
});

export const SecondaryButton = styled(Button)({
  ...actionButton,
  backgroundColor: "#ffffff",
  border: `1px solid ${accent}`,
  color: accent,
  "&:hover": { backgroundColor: accentLight },
  "&.MuiButton-text": { color: accent },
  "&.MuiButton-text:hover": { backgroundColor: accentLight },
  "&.danger, &.danger.MuiButton-text": { borderColor: "#ef4444", color: "#ef4444" },
});

export const BoatCheckbox = styled(Checkbox)({
  padding: 4,
  color: accent,
  "&.Mui-checked, &.MuiCheckbox-indeterminate": { color: accent },
});

export const DialogFooter = styled(DialogActions)({
  justifyContent: "space-between",
  alignItems: "center",
  gap: 12,
  flexWrap: "wrap",
});

export const FooterNote = styled("div")({
  flex: 1,
  minWidth: 140,
  color: "#555555",
  fontSize: 12,
  "&.alert": { color: "#963d36" },
});

export const Compose = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "minmax(0, 0.9fr) minmax(0, 1.1fr)",
  gap: 22,
  [theme.breakpoints.down("sm")]: { gridTemplateColumns: "1fr" },
}));

export const ConversationPane = styled("section")(({ theme }) => ({
  minWidth: 0,
  paddingRight: 20,
  borderRight: "1px solid #e8e8e8",
  "& h3": { margin: "0 0 12px", fontSize: 12 },
  [theme.breakpoints.down("sm")]: {
    padding: "0 0 12px",
    borderRight: 0,
    borderBottom: "1px solid #e8e8e8",
  },
}));

export const Transcript = styled("div")(({ theme }) => ({
  maxHeight: 360,
  overflow: "auto",
  [theme.breakpoints.down("sm")]: { maxHeight: 190 },
}));

export const MessageCard = styled("article")({
  margin: "10px 0",
  padding: 12,
  border: "1px solid #d8d8d8",
  borderRadius: 8,
  "& h3": { margin: "0 0 5px", fontSize: 12 },
  "& p": {
    margin: "8px 0 0",
    fontSize: 12,
    lineHeight: 1.7,
    whiteSpace: "pre-wrap",
    overflowWrap: "anywhere",
  },
});

export const ContextList = styled("dl")(({ theme }) => ({
  margin: "12px 0 0",
  color: "#555555",
  fontSize: 12,
  "& div": { display: "grid", gridTemplateColumns: "90px 1fr", gap: 8, margin: "7px 0" },
  "& dd": { margin: 0, color: "#333333", overflowWrap: "anywhere" },
  [theme.breakpoints.down("sm")]: { display: "none" },
}));

export const InfoPanel = styled("div")({
  marginTop: 12,
  padding: "12px 13px",
  border: "1px solid #e8e8e8",
  borderRadius: 3,
  background: "#f1f1f1",
  color: "#333333",
  fontSize: 12,
  lineHeight: 1.65,
  whiteSpace: "pre-line",
});

export const SourceList = styled("div")({
  display: "grid",
  gap: 9,
});

export const SourceRow = styled("section")({
  padding: "11px 12px",
  border: "1px solid #d8d8d8",
  borderRadius: 7,
  "& h3": { margin: 0, fontSize: 13 },
  "& p": { margin: "6px 0", fontSize: 12, lineHeight: 1.6, whiteSpace: "pre-wrap" },
});

export const ComposeHead = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 10,
  marginBottom: 8,
});

export const SearchHit = styled("span")({
  marginLeft: 3,
  fontWeight: 800,
});
